export default __webpack_public_path__ + "static/media/love.67cdbe44.png";